import { Component, OnInit } from '@angular/core';
import { NbMenuItem } from '@nebular/theme';


@Component({
  selector: 'ngx-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
  // template: `
  //         <nb-layout>
  //           <nb-layout-header>
  //             Navbar
  //           </nb-layout-header>
  //           <nb-layout-column>
  //           </nb-layout-column>
  //         </nb-layout>  
  // `
})
export class AboutComponent {

  // constructor() { }

  // ngOnInit(): void {
  // }

}
